// React Imports
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// React Spectrum Components
import {
  ProgressCircle,
} from '@adobe/react-spectrum';

// I18n
import { Translate } from 'react-redux-i18n';

// React Router
import { withRouter } from '../withRouter';
// Utils
import { addCommaSeparator } from '../../util/util';

// Styles
import '../../styles/LoadMore.scss';

const LoadMore = ({ results }) => {
  /**
   * Render the result count or a loading spinner
   * @param {Object} results - The results from the Redux store
   */
  const renderResultCount = () => {
    if (results.loadingResults && Object.keys(results.cards).length > 0) {
      return (
        <ProgressCircle
          size="S"
          isIndeterminate
          aria-label="load-more-spinner"
        />
      );
    }
    if (results.totalResults > 0) {
      return (
        <Translate
          value="partner_finder.cards.display_number_of_cards"
          resultLength={addCommaSeparator(Object.keys(results.cards).length)}
          totalResults={addCommaSeparator(results.totalResults)}
        />
      );
    }
    return null;
  };

  return (
    <div className="cmp-loadMore">
      <div className="displayed-results">
        {renderResultCount()}
      </div>
    </div>
  );
};

LoadMore.propTypes = {
  /**
   * results {Object} - An object provided by mapStateToProps
   * that contains the total results with the current applied filters,
   * loading indicator and cards information fetched from the api
   */
  results: PropTypes.shape({
    totalResults: PropTypes.number,
    loadingResults: PropTypes.bool,
    cards: PropTypes.shape({}),
  }),
};

LoadMore.defaultProps = {
  results: {},
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  results: state.results,
});

export default withRouter(connect(mapStateToProps)(LoadMore));
